import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { FormGroupDirective, NgForm } from '@angular/forms';
import { AuthenticationService } from '../services/authentication.service';
import { SnackBarService } from '../services/snack-bar-service.service';
import { LoginModel } from '../model/login.model';
import { AbastecimentoHorarioService, RemoveBlockHourRequest, AddBlockHourRequest, BloqueioHorarioResponse } from '../services/abastecimento-horario.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatTable } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { IVeiculoModel } from '../veiculo/model/veiculo.model';
import { IFrotaModel } from '../frota/model/frota.model';
import { MatDialog } from '@angular/material/dialog';
import { PesquisaFrotaComponent } from '../frota/pesquisa-frota/pesquisa-frota.component';
import { PesquisaSubfrotaComponent } from '../subFrota/pesquisa-subfrota/pesquisa-subfrota.component';
import { ISubFrotaModel } from '../subFrota/model/subFrota.model';
import { FrotaService } from '../frota/frota.service';
import { LocalStorageService } from '../services/localstorage.service';
import { DeleteRestrictionComponent } from './components/delete-restriction/delete-restriction.component';

export class CustomErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

type TabType = 'frota' | 'subfrota' | 'veiculos';

enum TipoEntidadeBloqueada {
  Frota = 2,
  SubFrota = 6,
  Veiculo = 7
}

@Component({
  selector: 'app-abastecimento-horario',
  templateUrl: './abastecimento-horario.component.html',
  styleUrls: ['./abastecimento-horario.component.scss']
})
export class AbastecimentoHorarioComponent implements OnInit {
  usuario: LoginModel | undefined;
  tituloFuncionalidade = 'Bloqueio de Abastecimento por Horário';
  lblCod = '020850'; 
  lblDescricao = 'Bloqueio de Abastecimento por Horário'; 
  loading = 0;
  dataSource: any[] = [];
  columns: string[] = [
    'horaInicio',
    'horaFim',
    'domingo',
    'segunda',
    'terca',
    'quarta',
    'quinta',
    'sexta',
    'sabado',
    'ACAO_APAGAR'
  ];

  currentTab: TabType = 'frota';
  selectedVehicleId: number | undefined;
  selectedFleetId: number | undefined;
  selectedFleet: IFrotaModel | undefined;
  selectedSubFleet: ISubFrotaModel | undefined;
  selectedSubFleetId: number | undefined;

  restrictionForm: FormGroup;
  errorMessage = '';
  diasDaSemana = [
    { label: 'Dom', control: 'domingo' },
    { label: 'Seg', control: 'segunda' },
    { label: 'Ter', control: 'terca' },
    { label: 'Qua', control: 'quarta' },
    { label: 'Qui', control: 'quinta' },
    { label: 'Sex', control: 'sexta' },
    { label: 'Sáb', control: 'sabado' }
  ];

  @ViewChild(MatTable) table!: MatTable<any>;

  matcher = new CustomErrorStateMatcher();

  constructor(
    private authService: AuthenticationService,
    private snackBar: SnackBarService,
    private fb: FormBuilder,
    private service: AbastecimentoHorarioService,
    private dialog: MatDialog,
    private frotaService: FrotaService,
    private localStorageService: LocalStorageService
  ) {
    this.restrictionForm = this.fb.group({
      horaInicio: ['', [Validators.required]],
      horaFim: ['', [Validators.required]],
      diasSelecionados: [[]]
    });
  }

  ngOnInit(): void {
    this.usuario = this.authService.getDadosUserLocal();
    this.loading++;

    this.authService.validate(this.usuario?.retorno?.guid ?? '')
      .then((dados) => {
        if (!dados.sucesso) {
          this.snackBar.flashMessage(this.authService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
          this.usuario = undefined;
        } else {

          if (this.usuario?.retorno?.codigoEntidade) {
            const filtro = {
              guid: this.usuario.retorno.guid,
              coluna: '1',
              operador: 1,
              parametro: this.usuario.retorno.codigoEntidade.toString()
            };

            this.frotaService.listFrota(filtro).subscribe({
              next: (response) => {
                if (response.sucesso && response.retorno.length > 0) {
                  this.selectedFleet = response.retorno[0];
                  this.selectedFleetId = response.retorno[0].codigo;
                  this.loadRestrictions();
                }
              },
              error: () => {
                this.snackBar.flashMessage('Erro ao carregar a frota', ['snackbar-error'], 'Fechar', 3000);
              }
            });
          }
        }
      })
      .catch(() => {
        this.snackBar.flashMessage(this.authService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
      })
      .finally(() => {
        this.loading--;
      });
  }

  onTabChange(event: MatTabChangeEvent): void {
    this.currentTab = event.tab.textLabel.toLowerCase() as TabType;

    if (this.currentTab === 'frota') {
      this.selectedSubFleet = undefined;
      this.selectedSubFleetId = undefined;
      this.selectedVehicleId = undefined;
    } else if (this.currentTab === 'subfrota') {
      this.selectedVehicleId = undefined;
    }
    this.loadRestrictions();
  }

  onVeiculoSelected(event: any): void {
    if (event) {
      this.selectedVehicleId = event.codigo;
      this.loadRestrictions();
    }
  }

  openFleetSearch(): void {
    const dialogRef = this.dialog.open(PesquisaFrotaComponent, {
      width: '800px',
      height: '700px',
      data: {
        dataKey: {
          guid: this.usuario?.retorno?.guid,
          coluna: '1',
          operador: 1,
          parametro: ''
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data) {
        this.selectedFleet = result.data;
        this.selectedFleetId = result.data.codigo;

        this.selectedSubFleet = undefined;
        this.selectedSubFleetId = undefined;
        if (this.currentTab === 'frota') {
          this.loadRestrictions();
        }
      }
    });
  }

  openSubFleetSearch(): void {
    if (!this.selectedFleetId) {
      this.snackBar.flashMessage('Selecione uma Frota primeiro', ['snackbar-error'], 'Fechar', 0);
      return;
    }

    const dialogRef = this.dialog.open(PesquisaSubfrotaComponent, {
      width: '800px',
      height: '700px',
      data: {
        codigoFrota: this.selectedFleetId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data) {
        this.selectedSubFleet = result.data;
        this.selectedSubFleetId = result.data.codigo;
        if (this.currentTab === 'subfrota') {
          this.loadRestrictions();
        }
      }
    });
  }

  loadRestrictions(): void {
    if (!this.usuario?.retorno?.guid) return;

    if (this.currentTab === 'veiculos' && !this.selectedVehicleId) {
      this.dataSource = [];
      if (this.table) {
        this.table.renderRows();
      }
      return;
    }

    if (this.currentTab === 'subfrota' && !this.selectedSubFleetId) {
      this.dataSource = [];
      if (this.table) {
        this.table.renderRows();
      }
      return;
    }

    this.loading++;
    const userGuid = this.usuario.retorno.guid;
    let codEntidade: number;
    let codSubfrota: number | undefined = undefined;

    switch (this.currentTab) {
      case 'veiculos':
        codEntidade = this.selectedVehicleId!;
        codSubfrota = this.selectedSubFleetId;
        break;
      case 'subfrota':
        codEntidade = this.selectedSubFleetId!;
        break;
      case 'frota':
        codEntidade = this.selectedFleetId || this.usuario.retorno.codigoEntidade;
        break;
      default:
        codEntidade = this.usuario.retorno.codigoEntidade;
    }

    this.service.getRestrictions(userGuid, codEntidade, this.currentTab, codSubfrota).subscribe({
      next: (res: { sucesso: any; retorno: any[]; }) => {
        if (res.sucesso) {
          this.dataSource = res.retorno;
          if (this.table) {
            this.table.renderRows();
          }
        }
      },
      error: (error) => {
        this.snackBar.flashMessage('Erro ao carregar restrições', ['snackbar-error'], 'Fechar', 3000);
      },
      complete: () => {
        this.loading--;
      }
    });
  }

  onAddRestriction(): void {
    if (this.restrictionForm.valid) {
      this.loading++;

      const diasSelecionados = this.restrictionForm.get('diasSelecionados')?.value || [];

      const requestData: AddBlockHourRequest = {
        Guid: this.usuario?.retorno?.guid ?? '',
        CodEntidadeBloqueada: this.getEntityId(),
        CodTipoEntidadeBloqueada: this.getTipoEntidadeBloqueada(),
        HoraInicio: this.restrictionForm.get('horaInicio')?.value,
        HoraFim: this.restrictionForm.get('horaFim')?.value,
        Segunda: diasSelecionados.includes('segunda'),
        Terca: diasSelecionados.includes('terca'),
        Quarta: diasSelecionados.includes('quarta'),
        Quinta: diasSelecionados.includes('quinta'),
        Sexta: diasSelecionados.includes('sexta'),
        Sabado: diasSelecionados.includes('sabado'),
        Domingo: diasSelecionados.includes('domingo')
      };

      this.service.addHour(this.usuario?.retorno?.guid ?? '', requestData, this.currentTab).subscribe({
        next: (response: BloqueioHorarioResponse) => {
          if (response.sucesso) {
            this.loadRestrictions();
            this.restrictionForm.reset();
            this.snackBar.flashMessage('Restrição adicionada com sucesso!', ['snackbar-success'], 'Fechar', 2000);
          } else {
            this.snackBar.flashMessage('Erro ao adicionar restrição', ['snackbar-error'], 'Fechar', 3000);
          }
        },
        error: (error: unknown) => {
          this.snackBar.flashMessage('Erro ao adicionar restrição', ['snackbar-error'], 'Fechar', 3000);
        },
        complete: () => {
          this.loading--;
        }
      });
    }
  }

  handleAction(action: any, element: any): void {
    if (action.link === 'deleteRestriction') {
      const dialogRef = this.dialog.open(DeleteRestrictionComponent, {
        width: '400px'
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
          this.loading++;

          const requestData: RemoveBlockHourRequest = {
            Guid: this.usuario?.retorno?.guid ?? '',
            CodEntidadeBloqueada: element.codEntidadeBloqueada || this.getEntityId(),
            CodTipoEntidadeBloqueada: this.getTipoEntidadeBloqueada(),
            HoraInicio: element.horaInicio,
            HoraFim: element.horaFim,
            Segunda: element.segunda,
            Terca: element.terca,
            Quarta: element.quarta,
            Quinta: element.quinta,
            Sexta: element.sexta,
            Sabado: element.sabado,
            Domingo: element.domingo,
            CodBloqueio: element.codBloqueio
          };

          const userGuid = this.usuario?.retorno?.guid ?? '';

          this.service.deleteHour(userGuid, requestData, this.currentTab).subscribe({
            next: (response) => {
              if (response.sucesso) {
                this.loadRestrictions();
                this.snackBar.flashMessage('Restrição removida com sucesso!', ['snackbar-success'], 'Fechar', 2000);
              } else {
                this.snackBar.flashMessage('Erro ao remover restrição', ['snackbar-error'], 'Fechar', 3000);
              }
            },
            error: (error) => {
              this.snackBar.flashMessage('Erro ao remover restrição', ['snackbar-error'], 'Fechar', 3000);
            },
            complete: () => {
              this.loading--;
            }
          });
        }
      });
    }
  }

  private getTipoEntidadeBloqueada(): number {
    switch (this.currentTab) {
      case 'frota':
        return TipoEntidadeBloqueada.Frota;
      case 'subfrota':
        return TipoEntidadeBloqueada.SubFrota;
      case 'veiculos':
        return TipoEntidadeBloqueada.Veiculo;
      default:
        return TipoEntidadeBloqueada.Frota;
    }
  }

  private getEntityId(): number {
    switch (this.currentTab) {
      case 'veiculos':
        return this.selectedVehicleId!;
      case 'subfrota':
        return this.selectedSubFleetId!;
      case 'frota':
        return this.selectedFleetId!;
      default:
        return this.usuario?.retorno?.codigoEntidade ?? 0;
    }
  }

  onToggleTodosDias(event: MatSlideToggleChange): void {
    const selecionarTodos = event.checked;
    const diasControls = this.diasDaSemana.map(d => d.control);

    this.restrictionForm.patchValue({
      diasSelecionados: selecionarTodos ? diasControls : []
    });
  }

  formatTime(event: any, field: string): void {
    let value = event.target.value.replace(/\D/g, '');
    if (value.length >= 4) {
      const hours = value.substr(0, 2);
      const minutes = value.substr(2, 2);
      if (parseInt(hours) > 23) value = '23' + minutes;
      if (parseInt(minutes) > 59) value = hours + '59';
      value = hours + ':' + minutes;
    }
    this.restrictionForm.get(field)?.setValue(value);
  }

  static timeValidator(control: FormControl): { [key: string]: boolean } | null {
    const value = control.value;
    if (!value) {
      return { required: true };
    }
    if (!/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(value)) {
      return { invalidTime: true };
    }
    return null;
  }

  static diasSelecionadosValidator(control: FormControl): { [key: string]: boolean } | null {
    const value = control.value;
    if (!value || value.length === 0) {
      return { required: true };
    }
    return null;
  }

  onConfirm(): void {
    this.snackBar.flashMessage('Confirmação realizada!', ['snackbar-success'], 'Fechar', 2000);
  }

  onContinue(): void {
    this.snackBar.flashMessage('Continuando...', ['snackbar-success'], 'Fechar', 2000);
  }

  onSubfrotaSelected(subfrota: ISubFrotaModel | undefined): void {
    this.selectedSubFleet = subfrota;
    this.selectedSubFleetId = subfrota?.codigo;
    if (this.currentTab === 'subfrota') {
      this.loadRestrictions();
    }
  }
}